import script from "./auth.vue?vue&type=script&setup=true&lang=js"
export * from "./auth.vue?vue&type=script&setup=true&lang=js"

import "./auth.vue?vue&type=style&index=0&id=67b918ba&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.member/src/fe-member/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67b918ba"]])

export default __exports__